let events = [
    {
        date: new Date(1492, 9, 12),
        title: "Columbus Meets the Indians",
        text:
            "In 1492, Columbus stumbled upon the Americas when trying to find a new route to China. Believing he had reached India, he referred to the native inhabitants as “Indians”. He established a settlement on the island of Hispaniola in order to ship Indian slaves, gold, and sugar back to Spain. Columbus left a number of men on the islands to look after things while he left. Unfortunately for him, the Indians had killed the colonists of the islands by the time he came back. Infuriated, Columbus killed hundreds of Indians on Hispaniola and the adjacent islands. Columbus’s treatment of the natives signaled the beginning of european-indian relations for hundreds of years to come.",
        summary:
            "In 1492, Christopher Columbus sailed to the New World looking for China. The discovery led many nations to establish colonies there in the coming years. These colonies very often ignored the ways of life of the existing inhabitants, the Native Americans.",
        locations: [
            {
                name: "Hispaniola",
                link: "https://www.britannica.com/place/Hispaniola"
            }
        ],
        events: [
            {
                name: "Columbus “discovered” America",
                link: "http://www.eyewitnesstohistory.com/columbus.htm"
            },
            {
                name: "Hispaniola Massacre",
                link:
                    "https://gsp.yale.edu/case-studies/colonial-genocides-project/hispaniola"
            }
        ],
        dates: [
            {
                name: 'Columbus "discovers" America',
                dateString: "1492"
            }
        ],
        people: [
            {
                name: "Columbus",
                link: "https://www.biography.com/explorer/christopher-columbus"
            },
            {
                name: "Native Americans/American Indians",
                link: "https://www.britannica.com/topic/American-Indian"
            }
        ],
        learnMore: "American History book, pg. 22",
        imageUrl:
            "https://upload.wikimedia.org/wikipedia/commons/c/c2/Portrait_of_a_Man%2C_Said_to_be_Christopher_Columbus.jpg"
    },

    {
        date: new Date(1519, 0, 1),
        title: "Cortez Conquers the Aztecs",
        text:
            "The Aztects were a powerful group of Native Americans who ruled a large empire in what is now central Mexico during the 15th and 16th centuries. At the start of the 16th century, the Spanish learned of them and their rich empire. In 1519, the fearless Spanish leader Hernan Cortez led a group of conquistadors and nearby Indian tribes to conquer the great Aztec city of Tenochtitlan. The battle went on for months, but ended with the defeat of the Aztecs. Spanish forces enslaved the wartorn Indians and forced them to transform the palace into a Christian cathedral. This pattern of mistreatment towards the Indians for the purpose of gaining wealth and spreading religion would continue for hundreds of years in Mexico and the Colonies.",
        summary:
            "In 1519, a spanish conquistador named Hernan Cortez conquered the Aztec capital of Tenochtitlan in central Mexico. This was not the last time that foreign nations would mistreat Native Americans to gain wealth and spread religion.",
        locations: [
            {
                name: "Tenochtitlan",
                link: "https://www.ancient.eu/Tenochtitlan/"
            }
        ],
        events: [
            {
                name: " Cortez Conquered Tenochtitlan",
                link:
                    "https://www.history.com/this-day-in-history/aztec-capital-falls-to-cortes"
            }
        ],
        dates: [
            {
                name: "Cortez Conquered Tenochtitlan",
                dateString: "1519"
            }
        ],
        people: [
            {
                name: "Aztecs",
                link: "https://www.history.com/topics/ancient-americas/aztecs"
            },
            {
                name: "Hernan Cortez",
                link: "https://www.britannica.com/biography/Hernan-Cortes"
            }
        ],
        learnMore: "American History book, pg. 23",
        imageUrl:
            "https://cdn.britannica.com/76/133076-050-48D7AE58/Hernan-Cortes-Tenochtitlan-Spanish-troops-Aztec-1521.jpg"
    },

    {
        date: new Date(1492, 9, 12),
        title: "The Transatlantic Exchange",
        text:
            "Although Spanish forces and weaponry proved very deadly to Native Americans who only had primitive wooden and stone tools, one factor proved far deadlier: disease. Europeans introduced diseases into the Americas to which the Native Americans had no natural resistance. Europeans had built up resistance to these diseases over centuries, but the Indians were left defenceless. Disease combined with the brutal exploitation of the Native Americans reduced their population in Hispaniola from 300,000 in 1492 to 500 by 1548. Similar devastating epidemics happened later in mainland North and South America.",
        summary:
            "European immigrants proved deadly to Native Americans not only because of their superior weapons, but also because of the diseases they brought. Nearly all Indians in Hispaniola died from violence or disease between 1492 and 1548.",
        locations: [
            {
                name: "Hispaniola",
                link: "https://www.britannica.com/place/Hispaniola"
            }
        ],
        events: [
            {
                name: "American Indian epidemics",
                link: "https://www.nlm.nih.gov/nativevoices/timeline/183.html"
            }
        ],
        dates: [
            {
                name: "American Indian epidemics",
                dateString: "1492-1548"
            }
        ],
        people: [
            {
                name: "Spanish",
                link: "https://en.wikipedia.org/wiki/History_of_Spain"
            },
            {
                name: "Native Americans",
                link:
                    "https://www.history.com/topics/native-american-history/native-american-timeline"
            }
        ],
        learnMore: "American History book, pg. 24/25",
        imageUrl:
            "https://image.slidesharecdn.com/transatlanticslavetrade-150903200929-lva1-app6892/95/transatlantic-slave-trade-10-638.jpg?cb=1441311035"
    },

    {
        date: new Date(1500, 0, 1),
        title: "Spanish Missionary Efforts",
        text:
            "Spanish conquistadors were very effective at conquering Indians and establishing colonies for Spain, but often neglected those colonies. Spanish rulers often conquered tribes and enslaved them to work plantations, but practically wiped out the Indian population by doing so. Worried that too many potentially tax-paying subjects were being killed, the Spanish King ordered that the Indians be kept alive. In order to preserve rule over the Indians but keep them alive, the Spanish pushed a missionary effort in the Americas to convert the Indians to Christianity. Aside from wealth, religion was probably the main reason Europeans explored and conquered America.",
        summary:
            "During the 1500s, Spanish conquistadors killed many Native Americans. The Spanish King ordered that they be kept alive so they could pay taxes. In order to keep them alive but under control, the Spanish launched a missionary effort.",
        locations: [],
        events: [],
        dates: [
            {
                name: "Spanish Missionary Efforts",
                dateString: "1500s"
            }
        ],
        people: [
            {
                name: "Missionaries",
                link: "https://en.wikipedia.org/wiki/Missionary"
            }
        ],
        learnMore: "American History book, pg. 35",
        imageUrl:
            "https://tshaonline.org/sites/default/files/images/handbook/JJ/juarez-mission_0.jpg"
    },

    {
        date: new Date(1680, 6, 10),
        title: "The Pueblo Rebellion",
        text:
            "Many Indians were rightfully unhappy with missionary efforts. Missionaries commonly forced Native Americans to abandon all of their old religion and culture and fully embrace new and foreign ones. To please priests who enforced the missionary efforts, many Pueblos became public Christians, but still practiced their native faiths in private. When missionaries discovered that the Pueblos weren’t fully committed to Christianity, they inflicted harsh punishments on the Indians. Things got worse in the 1660s and 1670s when a prolonged drought reduced many Pueblos to starvation. Fed up with mistreatment, a Pueblo shaman named Pope encouraged resistance to Spanish missionaries. Pope also garnered support from the Apaches who also disliked Spanish Rule. Pope and his followers destroyed and plundered Spanish towns, and forced the colonial survivors into El Paso, Texas. Pope’s rebellion was the greatest blow the Indians ever dealt on colonial expansion. Unfortunately, war broke out between the Pueblos and Apaches after the Spanish were removed, and the Spanish were provided an opportunity to reclaim rule over the tribes. There was one silver lining to the whole situation: the Pueblos and Spanish had to learn how to cooperate after the rebellion, as they both needed protection from surrounding Apaches.",
        summary:
            "Most Indians weren’t happy with missionary efforts and still practiced their old faiths in private. When missionaries discovered this, they punished the Indians. A Pueblo leader named Pope led the Pueblos and Apaches in an uprising which pushed the colonial survivors into El Paso, Texas. The Spanish regained control, and ended up actually cooperating with the Pueblos.",
        locations: [
            {
                name: "El Paso, Texas",
                link: "https://www.elpasotexas.gov/"
            }
        ],
        events: [
            {
                name: "Pueblo Rebellion",
                link: "https://www.britannica.com/event/Pueblo-Rebellion"
            }
        ],
        dates: [
            {
                name: "Pueblo Rebellion",
                dateString: "1680"
            }
        ],
        people: [
            {
                name: "Pueblos",
                link: "https://www.britannica.com/topic/Pueblo-Indians"
            },
            {
                name: "Pope",
                link:
                    "https://www.britannica.com/biography/Pope-Tewa-Pueblo-leader"
            }
        ],
        learnMore: "American History book, pg. 39",
        imageUrl:
            "https://image.pbs.org/video-assets/pbs/finding-your-roots/14218/images/Mezzanine_512.jpg"
    },

    {
        date: new Date(1609, 5, 1),
        title: "Beaver Wars",
        text:
            "The French had mostly peaceful relations with Native Americans in Canada, at least at first. The French needed to keep hostilities with the Indians down because they relied on them for a profitable trade system. The French traded metal tools and weapons to the Indians for valuable furs, especially the beaver. The demand for beavers was so great that the Indians actually ended up over-hunting them, provoking wars between rival tribes. Samuel de Champlain, Quebec’s founder, traded with the Montagnais, Algonquin, and Huron Indians. Those tribes expected protection from the powerful Iroquois. In 1609, the French waged a devastating war against the Iroquois. The French were at a massive advantage, as they had far superior weapons which the Iriqouis were not prepared for. The Iriqouis were not prepared for the first war with the French, but learned from their mistakes. The Iriqouis never forgot the devastation that the French brought, and ravaged them for years to come with weapons acquired from Dutch traders.",
        summary:
            "The French settlers in Canada kept mostly peaceful relations with the Indians in the area, which they relied on for a profitable fur trade. Many of the Indian tribes they were allied with were enemies of the powerful Iroquois. The French attacked the Iroquois and easily won, but at a cost: the Iroquois would not forget the battle, and would wage attacks on the French for years to come.",
        locations: [
            {
                name: "Canada",
                link: "https://en.wikipedia.org/wiki/Canada"
            },
            {
                name: "Quebec",
                link: "https://en.wikipedia.org/wiki/Quebec"
            }
        ],
        events: [
            {
                name: "Beaver Wars",
                link: "https://en.wikipedia.org/wiki/Beaver_Wars"
            }
        ],
        dates: [
            {
                name: "Beaver Wars",
                dateString: "1609"
            }
        ],
        people: [
            {
                name: "French Canadians",
                link: "https://en.wikipedia.org/wiki/New_France"
            },
            {
                name: "Samuel de Champlain",
                link: "https://www.britannica.com/biography/Samuel-de-Champlain"
            },
            {
                name: "Montagnais",
                link: "https://en.wikipedia.org/wiki/Montagnais"
            },
            {
                name: "Algonquin",
                link: "https://www.britannica.com/topic/Algonquin"
            },
            {
                name: "Huron",
                link: "https://www.britannica.com/topic/Huron-people"
            },
            {
                name: "Iriquois",
                link: "https://www.britannica.com/topic/Iroquois-people"
            },
            {
                name: "Dutch Traders",
                link:
                    "https://en.wikipedia.org/wiki/Dutch_colonization_of_the_Americas"
            }
        ],
        learnMore: "American History book, pg. 41",
        imageUrl:
            "https://upload.wikimedia.org/wikipedia/en/2/2e/Champlain%27s_1609_battle_with_the_Iroquois.jpg"
    },

    {
        date: new Date(1580, 0, 1),
        title: "The British and Algonquin",
        text:
            "In the 1580s, England tried to establish its first colonies in the Americas. They first attempted to colonize a small island on the North Carolina coast named Roanoke, but failed because of its infertile soil and its unnavigable waterways. After the failure to colonize Roanoke, England sent more colonists to the superior Chesapeake Bay. The bay offered many navigable rivers and harbors, but was inhabited by 24,000 powerful Indians led by the powerful chief Powhatan. Additionally, the area was ripe with disease which weakened the colonists and made it hard to tend farms. In 1609, war broke out between the colonists and the Algonquin Indians. The war subsided in 1613 when the colonists captured Powhatan’s favorite daughter, Pocahontas, and Powhatan reluctantly made peace. Conflict arose again when Powhatan died and his brother Opechancanough rose to power.",
        summary:
            "It took a few tries before England successfully colonized America. They succeeded in colonizing the Chesapeake Bay, but had to fight off the many Algonquin Indians in the area.",
        locations: [
            {
                name: "Roanoke",
                link:
                    "https://www.history.com/news/what-happened-to-the-lost-colony-of-roanoke"
            },
            {
                name: "Chesapeake Bay",
                link:
                    "https://www.cbf.org/about-the-bay/chesapeake-bay-watershed-geography-and-facts.htm"
            }
        ],
        events: [
            {
                name: "Roanoke Colonization",
                link:
                    "https://www.history.com/this-day-in-history/roanoke-colony-deserted"
            },
            {
                name: "Chesapeake Bay Colonization",
                link:
                    "http://www.loc.gov/teachers/classroommaterials/presentationsandactivities/presentations/timeline/colonial/indians/"
            },
            {
                name: "Anglo-Powhatan Wars",
                link: "https://en.wikipedia.org/wiki/Anglo-Powhatan_Wars"
            }
        ],
        dates: [
            {
                name: "First English Colonies",
                dateString: "1580s"
            },
            {
                name: "Anglo-Powhatan Wars",
                dateString: "1609"
            }
        ],
        people: [
            {
                name: "Powhatan",
                link:
                    "https://www.britannica.com/biography/Powhatan-American-Indian-chief"
            },
            {
                name: "Pocahontas",
                link:
                    "https://www.history.com/topics/native-american-history/pocahontas"
            },
            {
                name: "Opechancanough",
                link:
                    "https://www.encyclopediavirginia.org/opechancanough_d_1646"
            }
        ],
        learnMore: "American History book, pg. 45",
        imageUrl:
            "https://tce-live2.s3.amazonaws.com/media/media/83a53c1a-6c97-475e-91de-f2c0fdc9d49f.jpg"
    },

    {
        date: new Date(1676, 5, 6),
        title: "Bacon's Rebellion",
        text:
            "By the 1670s, the population of Virginia was steadily increasing. Many colonists moved deeper and deeper into the colony, where it was more expensive to transport goods, and colonists faced greater danger from surrounding Indians. Feeling vulnerable, colonists begged the royal governor of Virginia, William Berkely, for permission to exterminate the colony’s Indians. Berkley refused, and colonists became even angrier at the already corrupt leader. Under Nataniel Bacon’s leadership, the colonists revolted and slaughtered the Indians anyway. After that, the men marched into Jamestown and rebelled against Berkely. Bacon’s Rebellion put more power into the hands of farmers and poor colonists, but only weakened the power that Indians had in the colonies. Throughout the modern history of America, many groups have made massive strides, but the Native Americans always seem to get the short end of the stick.",
        summary:
            "Many colonists in Virginia were growing unhappy with the leadership of governor William Berkely who was corrupt and prevented the extermination of Indians in Virginia. Nathaniel Bacon led a group of colonists to slaughter the Indians and rebel against Berkely in Virginia.",
        locations: [
            {
                name: "Jamestown",
                link:
                    "https://www.nps.gov/jame/learn/historyculture/bacons-rebellion.htm"
            }
        ],
        events: [
            {
                name: "Bacon’s Rebellion",
                link:
                    "https://www.encyclopediavirginia.org/bacon_s_rebellion_1676-1677"
            }
        ],
        dates: [
            {
                name: "Bacon’s Rebellion",
                dateString: "1676"
            }
        ],
        people: [
            {
                name: "William Berkely",
                link: "https://www.britannica.com/biography/William-Berkeley"
            },
            {
                name: "Nathaniel Bacon",
                link: "https://www.britannica.com/biography/Nathaniel-Bacon"
            }
        ],
        learnMore: "American History book, pg. 48",
        imageUrl:
            "https://www.history.com/.image/t_share/MTY1ODk0NzU4MzkxMDk2NzE0/bacons-rebellion-gettyimages-51246275.jpg"
    },

    {
        date: new Date(1636, 6, 1),
        title: "Pequot War",
        text:
            "In the 1600s, many New England colonists were Puritans. Puritans wished to purify the Anglican Church. The Puritans established a fur trade with nearby Indian tribes, but it was an uneasy one; Puritans saw Indians as lazy savages who simply accepted their life in nature without making an effort to conquer it. Eventually, rivalry over control of the trade and opposition to English territorial expansion led to the Pequot War. The Pequot, Puritans, and surrounding tribes fought back and forth for a while, resulting in the deaths of hundreds of people on all sides. In 1638, the Treaty of Hartford ended the war. The war virtually wiped out the Pequot, and the ones who remained were sometimes forced into praying towns where they assimilate to Puritan culture.",
        summary:
            "Puritans in New England had many differences with the Pequot Indians living in the area which eventually led to the Pequot War in 1636. The war virtually wiped out the Pequot in the area, and finally ended in 1639 with the Treaty of Hartford.",
        locations: [
            {
                name: "New England Colonies",
                link: "https://www.landofthebrave.info/new-england-colonies.htm"
            }
        ],
        events: [
            {
                name: "Pequot War",
                link: "https://www.britannica.com/topic/Pequot-War"
            }
        ],
        dates: [
            {
                name: "Pequot War",
                dateString: "1636"
            },
            {
                name: "Treaty of Hartford",
                dateString: "1638"
            }
        ],
        people: [
            {
                name: "Puritans",
                link:
                    "https://www.history.com/topics/colonial-america/puritanism"
            },
            {
                name: "Anglicans",
                link: "https://www.britannica.com/topic/Anglicanism"
            }
        ],
        learnMore: "American History book, pg. 53",
        imageUrl:
            "https://cdn.britannica.com/41/123641-004-1827792B/colonists-English-command-Capt-fort-Pequot-John-May-1637.jpg"
    },

    {
        date: new Date(1675, 4, 20),
        title: "King Philip's War",
        text:
            "In 1675, many Indian tribes were fed up with their treatment and led separate but similar attacks against the colonists. The colonists, believing that the attacks were part of one large coordinated movement led by the Indian chief Metacom, who the colonists called King Philip, named it King Philip’s War. With guns acquired from traders, the tribes destroyed 12 towns. Unfortunately for the Indians, colonists countered the attacks by destroying Indian crops and starving the Indians. The war ultimately ended when Metacom was killed by a praying town Indian who fought for the colonists. In total, King Philip’s War killed over 1,000 colonists and over 3,000 Indians. The war had a lasting effect on the surviving Indians. Many of them fled north to the French colony, and often sought revenge by raiding New England colonies.",
        summary:
            "Fed up with mistreatment, many Indian tribes in the New England area launched attacks against the colonists. They unleashed devastating damage, but were defeated when colonists destroyed their crops and killed Metacom, who was loosely their leader. The war killed over 4,000 people in total.",
        locations: [],
        events: [
            {
                name: "King Philip’s War",
                link: "https://www.britannica.com/event/King-Philips-War"
            }
        ],
        dates: [
            {
                name: "King Philip’s War",
                dateString: "1675"
            }
        ],
        people: [
            {
                name: "Metacom / King Philip",
                link: "https://www.britannica.com/biography/Metacom"
            }
        ],
        learnMore: "American History book, pg. 54",
        imageUrl:
            "https://cdn.britannica.com/22/184722-050-A40756D8/Native-Americans-log-cabin-fire-woodcut-King.jpg"
    },

    {
        date: new Date(1754, 0, 1),
        title: "French and Indian War",
        text:
            "Between 1689 and 1748, the British and French fought a series of wars that eventually spilled into North America. Indians were stuck in the middle of the battles, and both the French and the British tried to persuade them to join their side of the fight. Both sides gave generous gifts to the tribes, especially weapons. Most tribes fought for the French, reasoning that they could fight off the 70,000 French people living in North America if need be, but not the 1,500,000 British colonists. The British colonists named the resulting war the French and Indian War after their enemies. Despite having a vastly larger population, the British did not fare well at first. They lost a number of battles and weren’t very effective at driving out the French. The tide of war shifted in 1758 and 1759 after the British managed to cut off French shipping to the Americas. Many Indians deserted the French for the better supplied British, which only further put the French at a disadvantage. The war ended triumphantly for the British with the Treaty of Paris. The treaty granted the British land in Canada, the Great Lakes region, the Ohio River Valley, and Florida. The conquest of Canada was very unfortunate news for the Indians who held land and trade relations there, and would lead to Pontiac’s Rebellion.",
        summary:
            "The British and French were fighting in many different parts of the globe between 1689 and 1748, and conflict broke out in the colonies in 1756. In America, the French had the support of most Indians at first. When things looked pretty dismal for the French, most Indians jumped ship and joined the British. The Treaty of Paris ended the war and granted reparations to Britain, but the Indians gained nothing. Tensions between the British and Indians would later lead to Pontiac’s Rebellion.",
        locations: [
            {
                name: "Great Lakes region",
                link: "https://en.wikipedia.org/wiki/Great_Lakes_region"
            },
            {
                name: "Ohio River Valley",
                link:
                    "https://www.nkytribune.com/2019/10/our-rich-history-the-ohio-river-valley-was-the-epicenter-of-a-major-global-war/"
            },
            {
                name: "Florida",
                link: "https://www.history.com/topics/us-states/florida"
            }
        ],
        events: [
            {
                name: "The French and Indian War",
                link:
                    "https://www.history.com/topics/native-american-history/french-and-indian-war"
            },
            {
                name: "The Treaty of Paris",
                link:
                    "https://www.history.com/topics/american-revolution/treaty-of-paris"
            }
        ],
        dates: [
            {
                name: "French and Indian War/Seven Years’ War",
                dateString: "1756-1763"
            },
            {
                name: "Treaty of Paris",
                dateString: "1763"
            }
        ],
        people: [],
        learnMore: "American History book, pg. 86",
        imageUrl:
            "https://www.history.com/.image/t_share/MTU3ODc5MDg3MjQyODgwNzM1/french-and-indian-war.jpg"
    },

    {
        date: new Date(1763, 0, 1),
        title: "Pontiac's Rebellion",
        text:
            "The result of the French and Indian war was a terrible loss for the Indians. The British cut off delivery of goods to the Indians, affecting tribes from western Pennsylvania and Virginia. Hoping to weaken British control and lure the French back to the colonies, an Ottawa chief organized an attack on Detroit that would become known as Pontiac’s Rebellion. The Indians failed to capture the three largest and strongest British posts, and eventually ran out of supplies since their supply lines had been cut off. Although the rebellion was a failure, it did have one silver lining: sensing that the war with the Indians was more expensive than granting them respect, the British issued the Proclamation of 1763, which ordered colonial settlers to remain east of the Appalachian Mountains. Unfortunately, British authorities had trouble enforcing the proclamation.",
        summary:
            "Angered by the results of the French and Indian war, an Ottawa chief organized Pontiac’s Rebellion to try and lure the French back into America. The plan ultimately failed, but the British did issue the Proclamation of 1763 which was designed to keep colonists east of the Appalachian Mountains.",
        locations: [
            {
                name: "Detroit",
                link:
                    "https://ss.sites.mtu.edu/mhugl/2016/10/30/siege-of-detroit/"
            },
            {
                name: "Appalachian Mountains",
                link: "https://www.britannica.com/place/Appalachian-Mountains"
            }
        ],
        events: [
            {
                name: " Pontiac’s Rebellion",
                link:
                    "https://www.history.com/this-day-in-history/pontiacs-rebellion-begins"
            },
            {
                name: "Proclamation of 1763",
                link: "https://www.britannica.com/event/Proclamation-of-1763"
            }
        ],
        dates: [
            {
                name: "Pontiac’s Rebellion",
                dateString: "1763"
            },
            {
                name: "Proclamation of 1763",
                dateString: "1763"
            }
        ],
        people: [
            {
                name: "Ottawa",
                link: "https://www.britannica.com/topic/Ottawa-people"
            }
        ],
        learnMore: "American History book, pg. 88",
        imageUrl:
            "https://live.staticflickr.com/3250/2987334769_cca688419c_b.jpg"
    },

    {
        date: new Date(1775, 3, 19),
        title: "Indians side with British",
        text:
            "The Revolutionary War was a long and complicated ordeal. With the British and colonists pitted against each other, the Indians found themselves stuck in the middle of another war. Although most Indians sided with the French during the French and Indian war, most Indians sided with the British during the Revolutionary War. One reason for this is because the British issued the Proclamation of 1763, which promised to keep colonists east of the Appalacians. The Patriots largely ignored this treaty, making them the enemy in the eyes of the Indians.",
        summary:
            "Although both sides mistreated the Indians, most Indians sided with the British over the Patriots during the Revolutionary War. On major reason for doing so is that the British promised to keep colonists east of the Appalacians, but wouldn’t be able to enforce that if the United States seceded from Britain.",
        locations: [],
        events: [
            {
                name: "Revolutionary War",
                link:
                    "https://www.history.com/topics/american-revolution/american-revolution-history"
            }
        ],
        dates: [
            {
                name: "Revolutionary War",
                dateString: "1775-1783"
            }
        ],
        people: [
            {
                name: "Patriots",
                link:
                    "https://courses.lumenlearning.com/boundless-ushistory/chapter/patriots-and-loyalists/"
            }
        ],
        learnMore: "American History book, pg. 122",
        imageUrl:
            "https://www.history.com/.image/t_share/MTU4MDgwODE0MDYyNTExMzA4/american-revolution.jpg"
    },

    {
        date: new Date(1794, 7, 20),
        title: "Battle of Fallen Timbers",
        text:
            "Even after the Revolutionary War, many Indians kept their alliance with the British. Hoping to limit American expansion, the British supplied weapons to Miami Indians and their allies. Indians used these weapons to attack colonists on the frontier, making it very dangerous to expand past the Appalacians. In an attempt to prevent the Indians from attacking colonists on the frontier, Washington sent troops to the Ohio Valley in 1791. The Indians, armed with weapons supplied by the British, successfully fought off these attacks. This victory was short, however, as General Anthony Wayne defeated the Native American confederacy at the Battle of Fallen Timbers in 1794. The Indians were forced to sign the Treaty of Greenville, which gave most of Ohio to the U.S. government.",
        summary:
            "British-allied Indians continued to fight expansionists after the Revolutionary War. Hoping to stop these attacks, Washington sent troops to the Ohio Valley. The Indians fought off this attack, but were defeated in 1794 at the Battle of Fallen Timbers. They were forced to sign the Treaty of Greenville which gave most of Ohio to the U.S. government.",
        locations: [
            {
                name: "Ohio Valley",
                link: "https://en.wikipedia.org/wiki/History_of_Ohio"
            }
        ],
        events: [
            {
                name: "Battle of Fallen Timbers",
                link:
                    "https://www.history.com/topics/native-american-history/battle-of-fallen-timbers"
            },
            {
                name: "Treaty of Greenville",
                link: "https://www.britannica.com/event/Treaty-of-Greenville"
            }
        ],
        dates: [
            {
                name: "Washington sends troops to Ohio",
                dateString: "1791"
            },
            {
                name: "Battle of Fallen Timbers",
                dateString: "1794"
            }
        ],
        people: [
            {
                name: "Miami Indians",
                link: "http://ohiohistorycentral.org/w/Miami_Indians"
            },
            {
                name: "George Washington",
                link: "https://www.biography.com/us-president/george-washington"
            },
            {
                name: "General Anthony Wayne",
                link: "https://www.ushistory.org/Valleyforge/served/wayne.html"
            }
        ],
        learnMore: "American History book, pg. 198",
        imageUrl:
            "https://www.history.com/.image/t_share/MTU4MDgwODE0MDYyNTExMzA4/american-revolution.jpg"
    },

    {
        date: new Date(1812, 5, 18),
        title: "War of 1812 and Indian Resistance",
        text:
            "After the civil war, westward expansion sped up. Many Indians were displeased with this expansion, and were angered by the government’s repeated use of dishonest treaties to take their lands. In 1811, two Shawnee Indian brothers named Tenskwatawa and Tecumseh tried to organize an armed resistance against American expansion. While Tecumseh was trying to rally support for the movement, Governor William Henry Harrison led troops into the brothers’ village of Prophetstown and burned it down. This battle, called the Battle of Tippecanoe, caused the movement to lose some momentum, although many Indians came back to fight again. When the War of 1812 came around, America was ready to make its move on the Indians who were mostly allied with the British. The British and Indians in Canada successfully fended off Patriot militiamen a number of times in 1812 and 1813. They even managed to conquer Detroit. The British failed to conquer Canada, but did manage to defeat Britain’s Indian allies in the colonies. In 1813, William Henry Harrison killed Tecumseh, and in 1814, Andrew Jackson demolished the Creek Indians of Alabama. Jackson then invaded the Seminole Indians in Florida. The war went on for a period of time after the defeat of the Indians, and of course ended with the success of the Patriots.",
        summary:
            "Displeased with American expansion efforts, Shawnee Indians tried to organize an armed resistance. The group succeeded in a few battles, but were ultimately overpowered. The end of the War of 1812 symbolized the end of that particular uprising.",
        locations: [
            {
                name: "Prophetstown",
                link: "https://en.wikipedia.org/wiki/Prophetstown,_Illinois"
            },
            {
                name: "Tippecanoe",
                link: "https://www.britannica.com/event/Battle-of-Tippecanoe"
            },
            {
                name: "Alabama",
                link: "https://en.wikipedia.org/wiki/Alabama"
            }
        ],
        events: [
            {
                name: "Battle of Tippecanoe",
                link: "https://www.britannica.com/event/Battle-of-Tippecanoe"
            },
            {
                name: "War of 1812",
                link: "https://www.history.com/topics/war-of-1812/war-of-1812"
            }
        ],
        dates: [
            {
                name: "Tenskwatawa and Tecumseh Organize a Resistance",
                dateString: "1811 "
            },
            {
                name: "War of 1812",
                dateString: "1812-1815"
            }
        ],
        people: [
            {
                name: "Shawnee Indians",
                link:
                    "https://native-american-indian-facts.com/Northeast-American-Indian-Facts/Shawnee-Indian-Facts.shtml"
            },
            {
                name: "Tenskwatawa",
                link: "https://ohiohistorycentral.org/w/Tenskwatawa"
            },
            {
                name: "Tecumseh",
                link: "https://ohiohistorycentral.org/w/Tecumseh"
            },
            {
                name: "Governor William Henry Harrison",
                link:
                    "https://www.britannica.com/biography/William-Henry-Harrison"
            },
            {
                name: "Patriot militiamen",
                link:
                    "https://www.historyisfun.org/yorktown-victory-center/militia-in-the-revolutionary-war/"
            },
            {
                name: "Andrew Jackson",
                link: "https://www.biography.com/us-president/andrew-jackson"
            },
            {
                name: "Creek Indians",
                link:
                    "https://www.georgiaencyclopedia.org/articles/history-archaeology/creek-indians"
            },
            {
                name: "Seminole Indians",
                link: "https://www.semtribe.com/stof"
            }
        ],
        learnMore: "American History book, pg. 215",
        imageUrl:
            "https://cdn.britannica.com/s:800x450,c:crop/20/195120-138-7E92BF6E/American-Revolution-War-of-1812-Great-Britain-1812.jpg"
    },

    {
        date: new Date(1830, 4, 28),
        title: "Indian Removal Act",
        text:
            "When Andrew Jackson became president, many of his supporters lived in the South and expected him to remove the 60,000 Indians living in the region. The five tribes living in this region, the Cherokee, Chiksaw, Creek, Choctaw, and Seminole, had assimilated to white culture and were known as the “five civilized tribes”. Even so, many white Southerners saw them as uncivilized savages who could never fully assimilate. Between 1827 and 1830, the states of Georgia, Mississippi, and Alabama dissolved the Indian governments and seized their lands. In a Supreme Court decision, John Marshall ruled that the seizure was unconstitutional. President Jackson, who favored states rights, ignored the decision and said that the decision was up to the states. Jackson also urged Congress to pass the Indian Removal Act of 1830, which would move the tribes from their homes in the southeast to the west. Only the Choctaws and Chickasaws agreed to the migration. The Cherokees did not officially agree, but U.S. soldiers forced 16,000 Cherokees to walk from their lands to Oklahoma along the Trail of Tears. At least 4,000 Cherokees died on this journey. A similar thing happened with the Creek Indians. In Florida, the Seminoles fought the Second Seminole War. In the end, American troops forced most Seminoles to leave their lands. In the Midwest, a chief named Black Hawk led the resistance by the Sauk and Fox nations in what became known as Black Hawk’s War. They fought federal troops and local militia until they were crushed in 1832. The ruthless actions by Andrew Jackson made it clear that if Native Americans stood in the way of American expansion or culture, they would be crushed.",
        summary:
            "With the support of most Southerners, President Andrew Jackson unconstitutionally removed 60,000 Indians living in the region. Most tribes put up a fight, as they had assimilated to white culture and did not want to leave their lands. A number of wars were fought, but every Indian nation living in the South was eventually relocated to the West.",
        locations: [
            {
                name: "the South",
                link: "https://www.britannica.com/place/the-South-region"
            },
            {
                name: "Oklahoma",
                link: "https://en.wikipedia.org/wiki/Oklahoma"
            }
        ],
        events: [
            {
                name: "Indian Removal Act of 1830",
                link:
                    "https://history.state.gov/milestones/1830-1860/indian-treaties"
            },
            {
                name: "Trail of Tears",
                link:
                    "https://www.history.com/topics/native-american-history/trail-of-tears"
            },
            {
                name: "Second Seminole War",
                link: "https://www.britannica.com/event/Second-Seminole-War"
            },
            {
                name: "Black Hawk’s War",
                link: "https://www.britannica.com/event/Black-Hawk-War"
            }
        ],
        dates: [
            {
                name: "States dissolved Indian governments",
                dateString: "1827-1830"
            },
            {
                name: "Indian Removal Act",
                dateString: "1830"
            },
            {
                name: "End of Black Hawk’s War",
                dateString: "1832"
            }
        ],
        people: [
            {
                name: "The Five Civilized Tribes",
                link: "https://www.legendsofamerica.com/na-fivecivilizedtribes/"
            },
            {
                name: "John Marshall",
                link: "https://www.biography.com/political-figure/john-marshall"
            },
            {
                name: "Black Hawk",
                link:
                    "https://www.britannica.com/biography/Black-Hawk-Sauk-and-Fox-leader"
            }
        ],
        learnMore: "American History book, pg. 252",
        imageUrl:
            "https://www.history.com/.image/t_share/MTU3ODc5MDg1NjMxMDIyNDA5/trail-of-tears-hero.jpg"
    },

    {
        date: new Date(1598, 6, 11),
        title: "Indians in New Mexico",
        text:
            "In 1598, New Mexico was founded by New Spain. The region attracted few settlers because of the constant threat of war with nomadic Native Americans in surrounding areas. The few settlers in the area did receive some protection from an alliance with local Pueblo Indians, although a disease reduced the Pueblo population drastically between 1700 and 1765. In another part of the country, conflict between the Apaches and other Indian tribes pushed the Apaches out of their homes and into New Mexico, where they raided Pueblo and Spanish settlements. Frequent raids on Spanish settlements in New Mexico reduced the colony to poverty. Sensing that a change had to made, Spanish officials did two things to save the colony: first, they built stronger frontier defenses to protect against attacks, then they made alliances with some nomad tribes to counterattack the Apaches. Some Apache groups even accepted peace terms made by the Spanish. As the colony became safer, the population grew. By 1821, the Hispanic population had grown to about 40,000.",
        summary:
            "In 1598, New Mexico was founded by New Spain. It was a dangerous place to settle because of constant threat of battle with surrounding Indians. Settlers formed an alliance with Pueblos in the area, which proved important when Apaches migrated to the area and began attacking settlers. New Spain reinforced New Mexico, and by 1821, the Hispanic population had grown to about 40,000.",
        locations: [
            {
                name: "New Mexico",
                link: "https://en.wikipedia.org/wiki/New_Mexico"
            },
            {
                name: "New Spain",
                link: "https://en.wikipedia.org/wiki/New_Spain"
            }
        ],
        events: [
            {
                name: "Founding of New Mexico",
                link: "https://en.wikipedia.org/wiki/History_of_New_Mexico"
            }
        ],
        dates: [
            {
                name: "Founding of New Mexico",
                dateString: "1589"
            }
        ],
        people: [
            {
                name: "Apaches",
                link: "https://www.britannica.com/topic/Apache-people"
            }
        ],
        learnMore: "American History book, pg. 299",
        imageUrl:
            "https://www.socorronm.org/wp-content/uploads/2014/02/Members_Of_The_Alamo_Navajo_Reservation.jpg"
    },

    {
        date: new Date(1868, 3, 29),
        title: "Treaty of Fort Laramie",
        text:
            "During the 1800s, many Americans travelled westward to all parts of the country to fulfill the Manifest Destiny. Colonists used a variety of transportation methods to migrate, but wagon was probably the most popular. The government was worried that Plains Indians would attack these migrants, so they passed the Treaty of Fort Laramie to bound the Indians to territories away from the major trails. Most Indians ignored the treaty because it would mean they would have to stop pursuing buffalo that crossed the imaginary boundary.",
        summary:
            " In 1868, the Treaty of Fort Laramie was passed to keep Plains Indians away from trails colonists used to fulfill the Manifest Destiny. Most Indians ignored the treaty.",
        locations: [],
        events: [
            {
                name: "Manifest Destiny",
                link:
                    "https://www.history.com/topics/westward-expansion/manifest-destiny"
            },
            {
                name: "Treaty of Fort Laramie",
                link: "https://www.ourdocuments.gov/doc.php?flash=false&doc=42"
            }
        ],
        dates: [
            {
                name: "Treaty of Fort Laramie",
                dateString: "1868"
            }
        ],
        people: [
            {
                name: "Plains Indians",
                link: "https://www.britannica.com/topic/Plains-Indian"
            }
        ],
        learnMore: "American History book, pg. 304",
        imageUrl:
            "https://upload.wikimedia.org/wikipedia/commons/b/b6/Photograph_of_General_William_T._Sherman_and_Commissioners_in_Council_with_Indian_Chiefs_at_Fort_Laramie%2C_Wyoming%2C_ca._1_-_NARA_-_531079.jpg"
    },

    {
        date: new Date(1848, 0, 24),
        title: "Indians and the California Gold Rush",
        text:
            "In 1848, gold in California caused a mass migration to the region called the California Gold Rush. White miners wanted to discourage foreign settlement of the area for both racial reasons and because they would increase competition. In order to discourage Chinese settlement, they passed the Foreign Miners Tax which levied a heavy tax on foreign miners. White miners also terrorized and killed Native Americans in the region by the thousands. Many of the surviving Indians became workers on farms and ranches.",
        summary:
            "In order to discourage rivals from settling in California, many white settlers discriminated against foreign miners and local Indians. The Foreign Miners’ Tax was passed to officially discourage foreign settlement, especially of the Chinese.",
        locations: [
            {
                name: "California",
                link: "https://en.wikipedia.org/wiki/California"
            }
        ],
        events: [
            {
                name: "California Gold Rush",
                link:
                    "https://www.history.com/topics/westward-expansion/gold-rush-of-1849"
            },
            {
                name: "Foreign Miners’ Tax",
                link:
                    "http://explore.museumca.org/goldrush/curriculum/gamsaan/foreigntax2.html"
            }
        ],
        dates: [
            {
                name: "California Gold Rush",
                dateString: "1848"
            }
        ],
        people: [],
        learnMore: "American History book, pg. 315",
        imageUrl:
            "https://www-tc.pbs.org/wgbh/americanexperience/media/filer_public_thumbnails/filer_public/33/cc/33cc7d3d-1cd2-4558-ad7a-1204395370a3/goldrush_california_landscape_seeking_river_operations_california.jpg__2000x1328_q85_crop_subsampling-2_upscale.jpg"
    },

    {
        date: new Date(1850, 0, 1),
        title: "Indians forced onto Reservations",
        text:
            "In 1830, the government passed the Indian Removal Act, which moved thousands of Indians from their homes in the southeast to the west. At that point, the west was thought to be uninhabitable. By the 1850s, gold and silver had been discovered in Indian Territory and Native American land was again challenged. Americans also wanted to build a transcontinental railroad which would go through Indian territory. By the late 1860s, Indians were forced onto separate areas set aside by the government for the Indians’ use called reservations. It was already clear that Americans would not hesitate to migrate Indians if they inhabited valuable lands, but now it appeared that they couldn’t even live on lands specifically set aside for them. Conditions on the reservations were dismal, and would worsen in the 1870s.",
        summary:
            "The Indian Removal Act of 1830 had forced Indians into the west. In the 1850s, gold was found on this land. As if the Indian Removal Acts wasn’t horrible enough, the government forced the Indians in this land into even smaller regions called reservations.",
        locations: [
            {
                name: "Indian Territory",
                link: "https://www.britannica.com/place/Indian-Territory"
            }
        ],
        events: [
            {
                name: "Transcontinental Railroad",
                link:
                    "https://www.history.com/topics/inventions/transcontinental-railroad"
            }
        ],
        dates: [
            {
                name: "Ores discovered in Indian Territory",
                dateString: "1850s"
            },
            {
                name: "Indians forced into reservations",
                dateString: "1860s"
            }
        ],
        people: [],
        learnMore: "American History book, pg. 497",
        imageUrl:
            "https://upload.wikimedia.org/wikipedia/en/2/2e/Champlain%27s_1609_battle_with_the_Iroquois.jpg"
    },

    {
        date: new Date(1860, 0, 1),
        title: "War on the Frontier",
        text:
            "By the late 1860s, Indian civilizations were already being threatened due to their forced migration into reservations. To add to this turmoil, white settlers introduced diseases of which the Indians had no immunity. Additionally, hunters slaughtered hundreds of buffaloes every day, severely limiting the food source of many Indians. Some Indian tribes resisted relocation. A group of Sioux Indians attacked settlements in eastern Minnesota. In response, the government waged war against the Sioux and pushed them into the Dakotas. The Sioux movement sparked a number of other Indian uprisings, which added to the distrust Americans felt towards them. In 1864, John Chivington led the Sand Creek Massacre, where a band of Colorado militia killed a group of Indians under U.S. Army protection. The massacre spawned another round of warfare, and praise turned to scorn for the commanding officer who led the attack, John Chivington. In 1866, warrior Red Cloud and his followers lured Captain William Fetterman and his troops into an ambush, killing them all. It was clear that something had to be done to improve relations between Native Americans and colonists.",
        summary:
            "By the late 1860s, Indian culture was being threatened by the government who forced tribes onto reservations, and hunters who killed hundreds of buffalo everyday for sport. Some tribes tried to withstand the changes and remain on their own land. A series of wars across the country resulted, and made it clear that a new system needed to be put in place.",
        locations: [
            {
                name: "Minnesota",
                link: "https://en.wikipedia.org/wiki/Minnesota"
            }
        ],
        events: [
            {
                name: "Sioux War",
                link:
                    "http://www.nativepartnership.org/site/PageServer?pagename=airc_hist_siouxwars"
            },
            {
                name: "Sand Creek Massacre",
                link: "https://www.britannica.com/event/Sand-Creek-Massacre"
            },
            {
                name: "Red Cloud’s War",
                link: "https://en.wikipedia.org/wiki/Red_Cloud%27s_War"
            }
        ],
        dates: [
            {
                name: "Sand Creek Massacre",
                dateString: "1864"
            },
            {
                name: "Red Cloud’s War",
                dateString: "1866"
            }
        ],
        people: [
            {
                name: "Sioux",
                link: "https://www.britannica.com/topic/Sioux"
            },
            {
                name: "John Chivington",
                link: "https://www.legendsofamerica.com/ah-johnchivington/"
            },
            {
                name: "Red Cloud",
                link:
                    "https://www.britannica.com/biography/Red-Cloud-Sioux-chief/"
            },
            {
                name: "Captain William Fetterman",
                link:
                    "https://www.history.com/this-day-in-history/indians-massacre-fetterman-and-eighty-soldiers"
            }
        ],
        learnMore: "American History book, pg. 498",
        imageUrl:
            "https://www.nps.gov/sand/learn/historyculture/images/Lindneaux-Painting.jpg?maxwidth=1200&autorotate=false"
    },

    {
        date: new Date(1868, 3, 29),
        title: "War and Peace on the Plains",
        text:
            "In an effort to ease tensions with the Sioux and gain more land, the government signed the Treaty of Fort Laramie in 1868. The treaty stated that the government would not build the transcontinental railroad through Sioux territory, and that they would abandon three forts if the Sioux agreed to live on a reservation. Unfortunately, this treaty only alleviated tensions for a short while, and the government soon broke their promises. Frustrated with the situation, many Native Americans turned to violence. The southern Plains Indians rebelled because the government failed to keep buffalo hunters off of their lands. In a series of major and minor incidents, the powerful southern Plains Indians were defeated in the Red River War. In the Northern Plains, the lure of gold threatened Indian tribes. Sitting Bull and Crazy Horse led the Sioux to drive the prospectors out, and successfully led a charge against U.S. troops at the Battle of the Little Big Horn. Americans cried for revenge, pressuring Crazy Horse and his followers to surrender. Sitting Bull and his followers escaped to Canada. ",
        summary:
            "To ease tensions with the Indian tribes, the government created a treaty which granted concessions to the tribes. The government soon broke their promises, and the Indian tribes rebelled. The Indian tribes ultimately lost all major wars, and the treaty left the tribes in a worse place than before it had been signed.",
        locations: [],
        events: [
            {
                name: "Red River War",
                link: "https://www.britannica.com/event/Red-River-Indian-War"
            },
            {
                name: "Battle of the Little Big Horn",
                link:
                    "https://www.history.com/topics/native-american-history/battle-of-the-little-bighorn"
            }
        ],
        dates: [
            {
                name: "Treaty of Fort Laramie",
                dateString: "1868"
            },
            {
                name: "Red River War",
                dateString: "1874-1875"
            },
            {
                name: "Battle of the Little Big Horn",
                dateString: "1876"
            }
        ],
        people: [
            {
                name: "Sitting Bull",
                link:
                    "https://www.history.com/topics/native-american-history/sitting-bull"
            },
            {
                name: "Crazy Horse",
                link:
                    "https://www.history.com/topics/native-american-history/crazy-horse"
            }
        ],
        learnMore: "American History book, pg. 500",
        imageUrl:
            "https://www.texasbeyondhistory.net/redriver/images/ledger-sm2.jpg"
    },

    {
        date: new Date(1877, 0, 1),
        title: "Chief Joseph and the Nez Perez",
        text:
            "In 1877, the federal government decided to move the Nez Perces living in Idaho to a smaller reservation to make room for white settlers. The Nez Perces had assimilated to white culture, and had a great deal to lose. Trying to evade U.S. troops, Chief Joseph led the Nez Perces on a 1,300 mile journey to Canada. Stopped just short of the border, Chief Joseph surrendered. He and his group was banished to a barren reservation in Oklahoma. This ordeal made it clear that even if Indians assimilated to white culture, they would still be treated as second class citizens.",
        summary:
            " In an all to familiar situation, the government tried to move the Nez Perez tribe living in Idaho to a reservation to make room for white settlers. They tried to flee to Canada, but failed.",
        locations: [],
        events: [],
        dates: [
            {
                name: "Chief Joseph leads Nez Perces to Canada",
                dateString: "1877"
            }
        ],
        people: [
            {
                name: "Nez Perces",
                link:
                    "https://www.history.com/this-day-in-history/chief-joseph-surrenders"
            },
            {
                name: "Chief Joseph",
                link: "https://www.britannica.com/biography/Chief-Joseph"
            }
        ],
        learnMore: "American History book, pg. 502",
        imageUrl:
            "https://cdn.britannica.com/87/91987-050-4C5A824C/Chief-Joseph-photograph-Nez-Perce-Edward-S-1903.jpg"
    },

    {
        date: new Date(1890, 11, 29),
        title: "The Ghost Dance War",
        text:
            "In response to their mistreatment by the U.S. government, many Indians welcomed a religious revival based on the Ghost Dance. Indians believed the revival would banish white settlers and restore the buffalo to the Plains. The practice spread like wildfire, and the government took notice. In an effort to curtail the activities, the government ordered the arrest of Sitting Bull (who was not a Ghost Dancer). While fleeing authorities, he and several others were killed. The Ghost Dance War ended at the Battle of Wounded Knee when well-armed cavalry met and outgunned Indians at Wounded Knee, South Dakota. The Ghost Dance was one of the last major uprisings that Indians would ever attempt.",
        summary:
            "Fed up with white efforts to control Indian tribes, many Indians joined the Ghost Dance cult which they believed would drive away the whites. Fearing what the practice would lead to, the government killed Sitting Bull, who they believed was one of its leaders. The Ghost Dance war ended at the Battle of Wounded Knee, and was one of the last major uprisings Indians would ever attempt.",
        locations: [
            {
                name: "Wounded Knee, South Dakota",
                link: "https://en.wikipedia.org/wiki/Wounded_Knee,_South_Dakota"
            }
        ],
        events: [
            {
                name: "The Ghost Dance",
                link: "https://www.britannica.com/topic/Ghost-Dance"
            },
            {
                name: "Battle of Wounded Knee",
                link:
                    "https://www.history.com/topics/native-american-history/wounded-knee"
            }
        ],
        dates: [
            {
                name: "The first Ghost Dance",
                dateString: "1869"
            },
            {
                name: "Battle of Wounded Knee",
                dateString: "1890"
            },
            {
                name: "Sitting Bull killed",
                dateString: "1890"
            }
        ],
        people: [],
        learnMore: "American History book, pg. 502/503",
        imageUrl:
            "https://cdn.britannica.com/59/145559-050-05039ACD/Ghost-Dance-Sioux-wood-engraving-1891.jpg"
    },

    {
        date: new Date(1887, 1, 8),
        title: "Dawes General Allotment Act",
        text:
            "The reservation policy was clearly a failure. Trying to confine Indians to small reservations left them angry at Americans and the government, and most Indians failed to adapt to farming lifestyles. In an attempt to get Indians to assimilate to white culture, Congress passed the Dawes General Allotment Act in 1887. The act replaced the reservation system with an allotments system where each Indian family was granted a 160-acre farmstead. To prevent the sale of the land to investors who would take advantage of the Indians, the act also specified that the land could not be sold or transferred for 25 years. Congress hoped that in that time, the new Indian owners would embrace farming and individual land ownership. To speed up the assimilation, reformers also established boarding schools for Indian children.",
        summary:
            "In an attempt to assimilate Indians to white culture, Congress passed the Dawes General Allotment Act in 1887. The act tried its best to make sure that Indians would adopt farms on their land, but failed to realize that farms take up more space in the west than in the east. Reformers also established organizations and boarding schools for Indian children to speed up assimilation.",
        locations: [],
        events: [
            {
                name: "Dawes General Allotment Act",
                link:
                    "https://www.britannica.com/topic/Dawes-General-Allotment-Act"
            }
        ],
        dates: [
            {
                name: "Dawes General Allotment Act",
                dateString: "1887"
            }
        ],
        people: [],
        learnMore: "American History book, pg. 504",
        imageUrl:
            "https://iloveancestry.com/wp-content/uploads/2017/05/dawes2-general-allotment-ac.jpg"
    },

    {
        date: new Date(2019, 11, 5),
        title: "Conclusion - The Impact of Native Americans",
        text:
            "From the moment Native Americans arrived in the Americas tens of thousands of years ago, they have had a massive impact on the history of the continents. Before the arrival of Europeans, many diverse and advanced tribes sprung up in every corner of America. Since the arrival of Christopher Columbus in the Bahamas, they have played perhaps an even more important but complicated role in the heritage of the country. On countless occasions, various tribes have been wiped out by violence and disease, had their land seized, and their way of life stripped away from them. They have been stuck in the middle of countless wars, battles, and skirmishes, yet they have nothing to show for it. In every sense of the word, Native Americans have been cheated. At this point, there are few things we could do to make reparations to the Native Americans, but that doesn’t mean we shouldn’t try. Today, Native Americans are still mistreated and fighting oppression. It is important that we remember and respect the Indians that helped make America, because it wouldn’t look the same today if not for the sacrifices they were forced to make.",
        summary:
            "From the moment of first contact, Europeans have mistreated Native Americans. They have stolen from, enslaved, and relocated Indians, hardly ever paying any reparations. America would look very different today if not for the sacrifices they made, so we should always remember and respect the legacy they left.",
        locations: [],
        events: [],
        dates: [
            {
                name: "European-Interaction Shape America",
                dateString: "1492-2019"
            }
        ],
        people: [],
        learnMore: "American History book",
        imageUrl:
            "https://i.pinimg.com/originals/c8/54/5b/c8545b91bc464146221c949dae287227.jpg"
    }
];

events = events.map(event => {
    return { ...event, buttonText: "Learn More" };
});

export default events;
